// @flow
import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import PageHeader from '../../PageHeader.jsx';

import SummaryPage from './SummaryPage.jsx';
import ViewReportPage from './ViewReportPage.jsx';
import EditReportPage from './EditReportPage.jsx';

type Props = {
  match: Object,
  history: Object,
}

class CounselingReportsPage extends Component<Props> {
  closePage = () => {
    this.props.history.push(`${this.props.match.url}`);
  }

  render() {
    return (
      <div>
        <PageHeader title='Counseling Reports' />
        <Switch>
          <Route
            path={`${this.props.match.url}/add`}
            render={() => (<EditReportPage closePage={this.closePage} />)} />
          <Route
            path={`${this.props.match.url}/:id/view`}
            render={({ match }) => (<ViewReportPage closePage={this.closePage} reportId={match.params.id} />)} />
          <Route
            path={`${this.props.match.url}/:id/edit`}
            render={({ match }) => (<EditReportPage closePage={this.closePage} reportId={match.params.id} />)} />
          <Route component={SummaryPage} />
        </Switch>
      </div>
    );
  }
}

export default CounselingReportsPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/counseling/CounselingReportsPage.jsx